<div class="container">
    <div class="users-header">
        <div class="actions">
            <div class="start">
                <div class="start-content-wrapper">
                    <div class="all-users-tag">
                        All Users
                        <span class="user-count-badge">{{ totalLength || 0 }}</span>
                    </div>
                    <div *ngIf="userPrivileges.has('user.view')" class="search-container" [formGroup]="searchForm">
                        <em class="pi pi-search search-icon"></em>
                        <input class="search-input" type="text" formControlName="search" placeholder="Search User"
                            [attr.aria-label]="'Search input'">
                    </div>
                </div>
            </div>
            <div class="end" style="display: flex; align-items: center;">
                <button class="action-item" *ngIf="false">
                    <img src="./assets/icons-svg/search-normal.svg" />
                </button>
                <button class="action-item" *ngIf="false">
                    <img src="./assets/icons-svg/filter-new.svg" />
                </button>
                <button *ngIf="userPrivileges.has('user.export')" class="action-item" (click)="showDownloadSidebar = true; showFilterSidebar = false">
                    <img src="./assets/icons-svg/download.svg" />
                </button>
                <button class="action-item" (click)="getAllUsers()">
                    <img src="./assets/icons-svg/rotate-right.svg" />
                </button>
                <p-select class="view-list-dropdown" [options]="pageLimits" [(ngModel)]="pageSize" (onChange)="getUsersByLimit()"></p-select>
                <div class="pages">
                    <button pButton icon="pi pi-angle-left" class="p-button-secondary p-button-text simple-btn"
                        (click)="prev()" [disabled]="isFirstPage()"></button>
                    <button pButton class="disabled p-button-secondary p-button-text simple-btn">
                        {{ pageNumber }} of {{ totalPages }}
                    </button>
                    <button pButton icon="pi pi-angle-right" class="p-button-secondary p-button-text simple-btn"
                        (click)="next()" [disabled]="isLastPage()"></button>
                </div>
            </div>
        </div>
    </div>
    <div class="users-content">
        <p-table #dt responsiveLayout="scroll" dataKey="id" [exportFilename]="exportName" [globalFilterFields]="['userType']"
            [columns]="usersCol" scrollHeight="flex" [value]="usersList" [resizableColumns]="true" [rows]="pageSize"
            scrollDirection="both" [loading]="loadingSpinner" [scrollable]="true" (onSort)="onSort($event)" [styleClass]="'users-list-table'" [tableStyleClass]="!usersList?.length ? 'empty' : ''">
            <ng-template let-columns pTemplate="header">
                <tr>
                    <th [style]="{width: col.field === 'is_sso_user' || col.field === 'is_active' ? '5vw !important' : col.field === 'mobile_number' ? '7vw !important' : '10vw !important'}" scope="col" [pSortableColumn]="col.field === 'email' || col.field === 'first_name' ? col.field : null"
                        *ngFor="let col of columns" pResizableColumn class="table-heading">
                        {{ col.header | uppercase }}
                        <p-sortIcon class="sort-icon" *ngIf="col.field === 'email' || col.field === 'first_name'" field="{{ col.field }}">
                        </p-sortIcon>
                    </th>
                    <th [style]="{width: '10vw !important'}" *ngIf="userPrivileges.has('user.update') || userPrivileges.has('user.delete')" scope="col" class="table-heading">
                        ACTION
                    </th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-user let-columns="columns">
                <tr class="row-user-list"
                    [style]="{cursor: 'pointer'}">
                    <td [style]="{width: col.field === 'is_sso_user' || col.field === 'is_active' ? '5vw !important' : col.field === 'mobile_number' ? '7vw !important' : '10vw !important'}" *ngFor="let col of columns">
                        <span [ngSwitch]="true">
                            <span *ngSwitchCase="col.field === 'userType'">
                                {{ userTypes[user[col.field]] }}
                            </span>
                            <span *ngSwitchCase="col.field === 'is_active'">
                                <span [ngClass]="{'text-success': user.is_active, 'text-danger': !user.is_active}">
                                    {{ user.is_active ? 'Active' : 'Inactive' }}
                                </span>
                            </span>
                            <span *ngSwitchCase="col.field === 'is_sso_user'">
                                {{ user.is_sso_user ? 'Yes' : 'No' }}
                            </span>
                            <span *ngSwitchDefault>
                                {{ user[col.field] ? user[col.field] :'-' }}
                            </span>
                        </span>
                    </td>
                    <td [style]="{width: '10vw !important'}" *ngIf="userPrivileges.has('user.update') || userPrivileges.has('user.delete')">
                        <p-button class="edit-user-button" label="Edit" link severity="help" *ngIf="userPrivileges.has('user.update')"
                            (click)="editUser(user)" />
                        <p-button label="Delete" link severity="danger" *ngIf="userPrivileges.has('user.delete')"
                            (click)="deleteUserConfirmation(user, $event)" class="delete-link" />
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="8" style="padding: 20px;">
                        <empty-state>
                            <empty-state-title>No Users Found</empty-state-title>
                            <empty-state-subtitle>We couldn't find any users matching your search.</empty-state-subtitle>
                        </empty-state>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>

<div class="user-header" *ngIf="addUserSlider">
    <ng-container>
        <p-dialog [header]="userData?.isUpdate ? 'Update User' : 'Create New User'" [(visible)]="addUserSlider" [modal]="true" [closable]="true" [draggable]="false"
            [resizable]="false" (onHide)="getAllUsers()">
            <app-add-user *ngIf="addUserSlider" [data]="userData" (userAdded)="onUserAdded($event)" (userUpdated)="onUserUpdated($event)"></app-add-user>
        </p-dialog>
    </ng-container>
</div>

<!-- Download Sidebar -->
<p-drawer   
  styleClass="downloadSidebar"   
  [transitionOptions]="'300ms'"   
  [(visible)]="showDownloadSidebar"   
  [modal]="false"  
  position="right"  
  [showCloseIcon]="false"  
  [baseZIndex]="1000"
  (visibleChange)="downloadHide()">
    <div class="download-sidebar-header">
        <div class="header-top-row">
            <h3 class="download-sidebar-title">Download Data</h3>
            <div class="format-toggle">
                <div class="format-option">
                    <div class="format-radio" [ngClass]="{'active': downloadAs === 'csv'}" (click)="downloadAs = 'csv'">
                        <i class="pi pi-check" *ngIf="downloadAs === 'csv'"></i>
                    </div>
                    <span class="format-label" (click)="downloadAs = 'csv'">CSV</span>
                </div>
                <div class="format-option">
                    <div class="format-radio" [ngClass]="{'active': downloadAs === 'excel'}" (click)="downloadAs = 'excel'">
                        <i class="pi pi-check" *ngIf="downloadAs === 'excel'"></i>
                    </div>
                    <span class="format-label" (click)="downloadAs = 'excel'">EXCEL</span>
                </div>
            </div>
        </div>
    </div>

    <div class="download-sidebar-content">
        <div class="download-columns-section">
            <div class="download-column-item select-all-item">
                <p-checkbox       
                    [(ngModel)]="selectAllColumnsForDownload"           
                    (onChange)="toggleSelectAll()"
                    [binary]="true"
                    inputId="selectAll">        
                </p-checkbox>        
                <label for="selectAll" class="download-column-label">Select All</label>      
            </div>
            
            <!-- Regular Column Items -->
            <div class="download-column-item" *ngFor="let col of colsToDownload">
                <p-checkbox           
                    name="downloadColumns"           
                    [value]="col"  
                    [(ngModel)]="checkedColumns"           
                    [inputId]="col.field"
                    (onChange)="onColumnCheckChange()">        
                </p-checkbox>        
                <label [for]="col.field" class="download-column-label">{{col.header}}</label>      
            </div>
        </div>
    </div>

    <div class="download-actions">
        <div class="download-buttons-row">
            <button         
                pButton         
                class="cancel-btn"         
                label="Cancel"        
                [outlined]="true" 
                (click)="showDownloadSidebar = false;">      
            </button>      
            <button         
                pButton         
                class="download-btn"         
                label="Download"         
                [disabled]="checkedColumns.length === 0"        
                (click)="(downloadAs === 'excel') ? exportUser('excel') : exportUser('csv')">      
            </button>    
        </div>    
    </div>

    @if (false) {
    <span class="p-input-icon-left">
        <em class="pi pi-search"></em>
        <input type="text" (ngModelChange)="searchColumns($event)" [(ngModel)]="downloadSearchTerm" pInputText
            placeholder="Search" />
    </span>
    <div [style]="{height: '42vh'}">
        <div *ngFor="let col of colsToDownload" class="field-checkbox">
            <p-checkbox [value]="col" name="category" [inputId]="col.field" [(ngModel)]="checkedColumns">
            </p-checkbox>
            <label [style]="{paddingLeft: '10px'}" [for]="col.field">{{col.header}}</label>
        </div>
    </div>
    <div class="download-container">
        <p>Download as</p>
        <div class="radioButton-group">
            <div class="radioButton">
                <p-radioButton [(ngModel)]="downloadAs" name="exportButtons" inputId="excel" value="excel">
                </p-radioButton>
                <label for="excel" class="radioBtn-label"
                    [style]="{color: downloadAs === 'excel' ? 'var(--fc-primary)' : 'var(--fc-light-dark)'}"><em
                        class="pi pi-file"></em>Excel</label>
            </div>
            <div class="radioButton">
                <p-radioButton value="csv" name="exportButtons" [(ngModel)]="downloadAs" inputId="csv">
                </p-radioButton>
                <label for="csv" class="radioBtn-label"
                    [style]="{color: downloadAs === 'csv' ? 'var(--fc-primary)' : 'var(--fc-light-dark)'}"><em
                        class="pi pi-file-excel"></em>CSV</label>
            </div>
        </div>
        <button pRipple pButton class="p-button-raised"
            (click)="(downloadAs === 'excel') ? exportUser('excel') : exportUser('csv')" type="button"
            label="Download"></button>
    </div>
    }
</p-drawer>
<p-toast></p-toast>
<p-confirmpopup></p-confirmpopup>


@if (false) {
<div class="table">
    <!-- Table -->
    <p-table #dt responsiveLayout="scroll" dataKey="id" [exportFilename]="exportName" [selection]="selectedUsers"
        (selectionChange)="onSelectedUserChange($event)" [globalFilterFields]="['userType']" [columns]="usersCol"
        scrollHeight="75vh" [value]="usersList" [resizableColumns]="true" [rows]="pageSize" scrollDirection="both"
        [loading]="loadingSpinner" [scrollable]="true" (onSort)="onSort($event)"
        [style]="{maxWidth: '70vw'}">
        <ng-template pTemplate="caption">
            <div class="caption table-header">
                <span class="table-header-left">
                    <!-- <button pButton class="p-button-text simple-btn{{showFilterSidebar ? '-active' : '' }}"
                        icon="pi pi-filter" (click)="showFilterSidebar = true; showDownloadSidebar = false">
                    </button> -->
                    <button *ngIf="userPrivileges.has('user.export')" pButton class="p-button-text simple-btn{{showDownloadSidebar ? '-active' : '' }}"
                        icon="pi pi-download" (click)="showDownloadSidebar = true; showFilterSidebar = false">
                    </button>
                    <button pButton class="p-button-text simple-btn" icon="pi pi-refresh" 
                    (click)="getAllUsers()">
                  </button>
                    <p-divider layout="vertical"></p-divider>
                    <label>Total List: <span [style]="{color: '#333333'}">{{ totalLength }}</span></label>
                </span>
                <span class="table-menu">
                    <button *ngIf="userPrivileges.has('user.create')" pButton pRipple label="Add Users" class="addUsers-button"
                    styleClass="p-button-sm mr-2 mb-2" (click)="userData= null;addUserSlider = true;"></button>
                    <p [style]="{paddingRight: '10px'}">View</p>
                    <p-select class="view-list-dropdown" [options]="pageLimits" [(ngModel)]="pageSize" (onChange)="getUsersByLimit()"></p-select>
                    <p-divider layout="vertical"></p-divider>
                    <button pButton class="disabled p-button-secondary p-button-text simple-btn">
                        {{ pageNumber }} of {{ totalPages }}
                    </button>
                    <button pButton icon="pi pi-angle-left" class="p-button-secondary p-button-text simple-btn"
                        (click)="prev()" [disabled]="isFirstPage()"></button>
                    <button pButton icon="pi pi-angle-right" class="p-button-secondary p-button-text simple-btn"
                        (click)="next()" [disabled]="isLastPage()"></button>
                </span>
            </div>
        </ng-template>
        <ng-template let-columns pTemplate="header">
            <tr [ngClass]="{'moveTable': showDownloadSidebar}" class="table-heading">
                <th pFrozenColumn scope="col" [style]="{width: '5vw', justifyContent: 'center', margin: 0}">
                    <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                </th>
                
                <th [style]="{width: '15vw'}" scope="col"
                    [pSortableColumn]="col.field === 'email' || col.field === 'first_name' ? col.field : null"
                    *ngFor="let col of columns" pResizableColumn>
                    {{ col.header }}
                    <p-sortIcon class="sort-icon" *ngIf="col.field === 'email' || col.field === 'first_name'"
                        field="{{ col.field }}">
                    </p-sortIcon>
                </th>
            </tr>
            <tr class="selection-operations-row" *ngIf="selectedUsers.length">
                <td pFrozenColumn class="selection-operations-options">
                    <span>{{selectedUsers.length}} Selected</span>
                    <button *ngIf="userPrivileges.has('user.update') && selectedUsers.length === 1" 
                        pButton pRipple label="Edit User" (click)="editUser(selectedUsers[0])"
                        [style]="{fontWeight: '500', marginRight: '10px'}" 
                        class="p-button-outlined">
                    </button>
                    <button *ngIf="userPrivileges.has('user.delete')" pButton pRipple label="Delete User" (click)="deleteUser(selectedUsers[0])"
                        [style]="{fontWeight: '500'}"
                        [disabled]="selectedUsers.length > 1 || selectedUsers[0].candidateCount > 0"></button>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-user let-columns="columns">
            <tr class="row-user-list" [ngClass]="{'moveTable': showFilterSidebar || showDownloadSidebar}"
                [style]="{cursor: 'pointer'}">
                <td [style]="{width: '5vw', justifyContent: 'center', margin: 0}" pFrozenColumn>
                    <p-tableCheckbox [value]="user"></p-tableCheckbox>
                </td>
              
                <td *ngFor="let col of columns" [style]="{width: '15vw'}">
                    <span [ngSwitch]="true">
                        <span *ngSwitchCase="col.field === 'userType'">
                            {{ userTypes[user[col.field]] }}
                        </span>
                        <span *ngSwitchCase="col.field === 'is_active'">
                            <span [ngClass]="{'text-success': user.is_active, 'text-danger': !user.is_active}">
                              {{ user.is_active ? 'Active' : 'Inactive' }}
                            </span>
                        </span>
                        <span *ngSwitchCase="col.field === 'is_sso_user'">
                            {{ user.is_sso_user ? 'Yes' : 'No' }}
                        </span>
                        <span *ngSwitchDefault>
                            {{ user[col.field] ? user[col.field] :'-' }}
                        </span>
                    </span>
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>
}